export enum AlertType {
    Success = "success",
    Error = "error",
    Info = "info",
    Warning = "warning",
  }